module.exports = __webpack_public_path__ + "img/11 mama.fcdff734.jpg";